import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fetchPartnersThunk,
  fetchPartnerBySlugThunk,
} from "./partners.actions";
// import { toast } from 'react-toastify';

export const fetchPartners = createAsyncThunk(
  "partners/fetchPartners",
  fetchPartnersThunk
);
export const fetchPartnerBySlug = createAsyncThunk(
  "partners/fetchPartnerBySlug",
  fetchPartnerBySlugThunk
);

export const partnersInitialState = {
  loading: false,
  list: {
    data: [],
    totalItems: null,
    totalPages: null,
  },
  blogItem: {
    is_fetch: false,
    data: {},
  },
};

const PartnersSlice = createSlice({
  name: "partners",
  initialState: partnersInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPartners.fulfilled, (state, { payload }) => {
        return { ...state, loading: false, list: payload };
      })
      .addCase(fetchPartners.pending, (state) => {
        return { ...state, loading: true };
      })
      .addCase(fetchPartners.rejected, (state) => {
        return { ...state, loading: false };
      })
      .addCase(fetchPartnerBySlug.fulfilled, (state, { payload }) => {
        return {
          ...state,
          blogItem: {
            is_fetch: true,
            data: payload,
          },
        };
      })
      .addCase(fetchPartnerBySlug.pending, (state) => {
        return {
          ...state,
          blogItem: {
            is_fetch: false,
            data: {},
          },
        };
      })
      .addCase(fetchPartnerBySlug.rejected, (state) => {
        return {
          ...state,
          blogItem: {
            is_fetch: false,
            data: {},
          },
        };
      });
  },
});

export default PartnersSlice.reducer;
